import { render } from "./HeroiconsSolidChevronRight.vue?vue&type=template&id=5a03d9de"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronRight.vue"]])

export default __exports__